import { useEffect } from 'react';
import { useApiContext, useGetFullInfo } from 'react-easyrocket';

export const useSetUserDataToLiveChat = () => {
  const { isAuthenticated } = useApiContext();
  const { fullInfo, isSuccess: getFullInfoSuccess } = useGetFullInfo();

  const email = fullInfo?.email;
  const name = fullInfo?.name;
  const loyaltyLevel = fullInfo?.level;

  useEffect(() => {
    if (isAuthenticated && getFullInfoSuccess) {
      if (email) {
        window.LiveChatWidget?.call?.('set_customer_email', email);
      }
      if (name) {
        window.LiveChatWidget.call('set_customer_name', fullInfo.name);
      }
      if (loyaltyLevel) {
        window.LiveChatWidget?.call('set_session_variables', {
          loyaltyLevel: loyaltyLevel
        });
      }
    }

    if (!isAuthenticated) {
      window.LiveChatWidget?.call?.('set_customer_email', ' ');
      window.LiveChatWidget?.call?.('set_customer_name', ' ');
      window.LiveChatWidget?.call('set_session_variables', {
        loyaltyLevel: ' '
      });
    }
  }, [email, getFullInfoSuccess, isAuthenticated, loyaltyLevel, name]);
};
